import { StackScreenProps } from "@react-navigation/stack";
import { DocketSettingsRootParamList } from "../../../../types";
import React from "react";
import DocketTemplate from "../../../../utilities/data/model/DocketTemplate";
import { useTranslation } from "react-i18next";
import { useDatabase } from "@nozbe/watermelondb/react";
import { useFocusEffect } from "@react-navigation/native";
import { Q } from "@nozbe/watermelondb";
import {
  FlatActionList,
  Text,
  Page,
  Button,
} from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";

export interface DocketSettingsScreenProps
  extends StackScreenProps<
    DocketSettingsRootParamList,
    "DocketSettingsScreen"
  > {}

export const DocketSettingsScreen = ({
  navigation,
}: DocketSettingsScreenProps) => {
  const [docketTemplates, setDocketTemplates] = React.useState<
    DocketTemplate[]
  >([]);

  const { t } = useTranslation("settings");
  const database = useDatabase();

  useFocusEffect(
    React.useCallback(() => {
      database
        .get<DocketTemplate>("docket_templates")
        .query(Q.where("deleted_at", Q.eq(null)))
        .then((p) => {
          setDocketTemplates(p);
        });
    }, [])
  );

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label={t("button.create_docket_template")}
          isAction
          onPress={() => {
            navigation.navigate("CreateDocketTemplateRootScreen", {
              screen: "ManageDocketTemplateRootScreen",
              params: {
                screen: "ManageDocketTemplateScreen",
              },
            });
          }}
          size="compact"
        ></Button>
      ),
    });
  }, []);

  return (
    <Page
      title="Docket Templates"
      secondaryTitle="Manage your docket templates"
    >
      <FlatActionList
        items={docketTemplates.map((docketTemplate) => ({
          key: docketTemplate.id,
          title: docketTemplate.name,
          subTitle: `${docketTemplate.filters.length} filters`,
          onPress: () => {
            navigation.navigate("EditDocketTemplateRootScreen", {
              screen: "ManageDocketTemplateRootScreen",
              docketTemplateId: docketTemplate.id,
            });
          },
          titleContent: ({ title, subTitle }) => (
            <View>
              {title}
              {subTitle}
            </View>
          ),
        }))}
      />
    </Page>
  );
};
